import { IAnnualReport, IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { IOptions, ISectionData } from '../../../../aumico-lib-annualreport-fe/src/lib';
import { ArFeatureBaseModel } from './arFeatureBase.model';

export interface ArFeatureBasePDFSectionFactory<Model extends ArFeatureBaseModel> {
    /**
     * This method shall be used by PDF Tron Mapper and by the Print Preview
     *
     * This method is used to convert the domain model into ISectionData
     * so that it's easy to use for PDF tron and the print preview.
     *
     * It must support:
     *  - converting domain model to ISectionData
     *  - supporting all print options which are supported by this feature
     *  - supporting translation to other languages
     *  - supporting different output formats (based on locales)
     *
     * TODO Refactor function to not need all options
     * @param annualReport
     * @param printOptions
     * @param annualReportForAutofill
     * @param reportOrder
     * @param options
     * @param predifinedLables
     * @param formatLocale
     * @param translationLocale
     * @param reportLocale
     */
    createSection(
        annualReport: IAnnualReport,
        printOptions: IPrintOptions,
        annualReportForAutofill: IAnnualReport,
        reportOrder: string[],
        options: IOptions,
        predifinedLables: Map<string, string>,
        formatLocale: string,
        translationLocale: string,
        reportLocale: string,
    ): ISectionData;

    /**
     * This method shall to display the domain model with standard print options
     *
     *
     * It must support:
     *  - converting domain model to ISectionData
     *  - supporting translation to other languages
     *  - supporting different output formats (based on locales)
     *
     * TODO Refactor function to support all options required
     * @param domainModel
     */
    createSectionWithDefaultOptions(domainModel: Model): ISectionData;
}
